import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';

const { WrappedButton, WrappedButtonType } = UI;
const { Session } = Utils;

export class LabsDefaultUIMenuItem extends Component {
	handleSwitchToNew = async e => {
		e.preventDefault();

		await Session.savePreferences([{ Name: 'DefaultUI', Value: 'Lazarus' }]);

		var hostname = window.location.hostname;
		var protocol = window.location.protocol;
		var lazarusHost =
			hostname === 'corp.stamps.com' || hostname.endsWith('.corp.stamps.com')
				? hostname + ':8443'
				: hostname
						.replace(/^print\./, 'app.web.')
						.replace(
							/^(account|contacts|history|mail|products)\.web\./,
							'app.web.'
						);
		window.location.href = protocol + '//' + lazarusHost;
	};

	render() {
		return (
			<div className="labs-default-ui-menu-item">
				<p className="labs-message">
					Test drive our new Stamps.com Mail page. You can return to the
					original experience at any time.
				</p>
				<WrappedButton
					label="Switch to new version"
					className="labs-switch-button"
					onClick={this.handleSwitchToNew}
					buttonType={WrappedButtonType.TertiaryGrey}
				/>
			</div>
		);
	}
}
